import FullPad from './FullPad';
import { DEFAULT_INPUT_PANEL_MEAS } from './constants';

export default FullPad;
export { DEFAULT_INPUT_PANEL_MEAS };
